(function (angular) {
	'use strict';

	angular
		.module('eventsModule')
		.directive('mixpanelScrollTrack', [
			'$window',
			'mixpanelFactory',
			'RevealService',
			mixpanelTrackFunction
		]);

	function mixpanelTrackFunction(
		$window,
		mixpanelFactory,
		RevealService
	) {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var isFired = false;
				
				var mixpanelProperties = {
					'Location' : attrs.mixpanelScrollTrack
				};

				var checkIfEventShouldFire = function () {
					if (!isFired && RevealService.isTopOfElementInViewport(elem[0])) {
						isFired = true;
						angular.element($window).off('scroll', checkIfEventShouldFire);
						mixpanelFactory.track('Scroll Tracked', mixpanelProperties);
					}
				};

				angular.element($window).on('scroll', checkIfEventShouldFire);
			}
		};
	}
})(window.angular);